import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
// delon
import { AlainThemeModule } from '@delon/theme';
import { DelonABCModule } from '@delon/abc';
import { DelonACLModule } from '@delon/acl';
import { DelonFormModule } from '@delon/form';
import { DelonChartModule } from '@delon/chart';
// i18n
import { TranslateModule } from '@ngx-translate/core';

import { EditorModule } from '@tinymce/tinymce-angular';
// region: third libs
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { CountdownModule } from 'ngx-countdown';

// import {TinyEditorComponent} from "./components/tiny-mce/tiny-mce";
const THIRDMODULES = [
  NgZorroAntdModule,
  CountdownModule,
];
// endregion

// region: your componets & directives
const COMPONENTS = [

];


const BROWSE_COMPONENTS = [

];

const FLOW_COMPONENTS = [];
const DIRECTIVES = [];
const PIPE = [];

// endregion

@NgModule({
  imports: [
    EditorModule,
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    AlainThemeModule.forChild(),
    DelonABCModule,
    DelonChartModule,
    DelonACLModule,
    DelonFormModule,
    // i18n
    TranslateModule,
    // third libs
    ...THIRDMODULES,
  ],
  declarations: [
    // your components
    ...COMPONENTS,
    ...BROWSE_COMPONENTS,
    ...FLOW_COMPONENTS,
    ...DIRECTIVES,
    ...PIPE
  ],
  exports: [
    EditorModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    AlainThemeModule,
    DelonABCModule,
    DelonChartModule,
    DelonFormModule,
    DelonACLModule,
    // i18n
    TranslateModule,
    // third libs
    ...THIRDMODULES,
    // your components
    ...COMPONENTS,
    ...BROWSE_COMPONENTS,
    ...DIRECTIVES,
    ...PIPE,
  ],
  providers: [],
  entryComponents: [...BROWSE_COMPONENTS],
})
export class AppSharedModule {
}
